(function () {
  const mediaSelector = 'img, picture, video, .media, [class*="image"], [class*="gallery"]';

  function isEditableElement(element) {
    return Boolean(
      element &&
        element.closest &&
        element.closest('input, textarea, select, button, [contenteditable="true"], [role="textbox"]')
    );
  }

  function isProtectedMedia(element) {
    return Boolean(element && element.closest && element.closest(mediaSelector));
  }

  document.addEventListener(
    'contextmenu',
    function (event) {
      if (isEditableElement(event.target)) return;
      if (isProtectedMedia(event.target)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (event) {
      if (isProtectedMedia(event.target)) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (isEditableElement(event.target)) return;

      const key = event.key ? event.key.toLowerCase() : '';
      const saveShortcut = (event.ctrlKey || event.metaKey) && key === 's';
      const printShortcut = (event.ctrlKey || event.metaKey) && key === 'p';

      if (saveShortcut || printShortcut) {
        event.preventDefault();
      }
    },
    true
  );
})();
